export default __webpack_public_path__ + "static/media/world-atlas-3-rMAX.1165eb0e.jpg";